import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AbstractRescaleToggle } from '../abstract-rescale-toggle';

@Component({
  selector: 'h3-split-view-rescale-toggle',
  templateUrl: './split-view-rescale-toggle.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SplitViewRescaleToggleComponent extends AbstractRescaleToggle {
  rescaleAll$ = this.store('rescaleAllFrames').$;
}
